// extracted by mini-css-extract-plugin
export default {"secondaryCtas":"VcN1kUVYUP","secondaryCta":"wi3dWm2ayR"};